import { useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";

interface IHandleUpdateStatusContratos {
  setOpenModalCancel: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UseFormCancelContratos = ({
  setOpenModalCancel,
}: IHandleUpdateStatusContratos) => {
  const { setAttTable, id } = useConfigPageContext();

  const { valuesInputCancelarContrato } = useContextContrato();

  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const handleUpdateStatusContratos = () => {
    setLoading(true);

    api
      .patch(`/contratos/updateStatus/${id}`, {
        description: valuesInputCancelarContrato.description || "",
        status: valuesInputCancelarContrato.status,
        date_update: valuesInputCancelarContrato.date,
      })
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable((item) => !item);
        setOpenModalCancel(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return {
    handleUpdateStatusContratos,
    loading,
  };
};
